import styled from 'styled-components';
import {
  FilterType,
  PTypeLandCategoty,
  PTypeResidentialCategory,
  PTypeCommercialCategory,
  PTypeIndustrialCategory,
  PTypeComplexCategory,
} from '../FilterData';

interface ItemStatusOptionProps {
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

const PItemStatusOption = ({ filters, setFilters }: ItemStatusOptionProps) => {
  const allSelected1 = PTypeLandCategoty.every((item) =>
    filters.multiItemStatus.includes(item.name),
  );
  const allSelected2 = PTypeResidentialCategory.every((item) =>
    filters.multiItemStatus.includes(item.name),
  );
  const allSelected3 = PTypeCommercialCategory.every((item) =>
    filters.multiItemStatus.includes(item.name),
  );
  const allSelected4 = PTypeIndustrialCategory.every((item) =>
    filters.multiItemStatus.includes(item.name),
  );
  const allSelected5 = PTypeComplexCategory.every((item) =>
    filters.multiItemStatus.includes(item.name),
  );

  const isSelectedAllOptions =
    allSelected1 &&
    allSelected2 &&
    allSelected3 &&
    allSelected4 &&
    allSelected5;

  const toggleFilter = (value: string) => {
    setFilters({
      ...filters,
      itemStatus: [],
      multiItemStatus: filters.multiItemStatus.includes(value)
        ? filters.multiItemStatus.filter((v) => v !== value)
        : [...filters.multiItemStatus, value],
    });
  };
  const toggleAllSelect = (
    state: boolean,
    data: { name: string; value: string }[],
  ) => {
    if (state) {
      setFilters({
        ...filters,
        itemStatus: [],
        multiItemStatus: filters.multiItemStatus.filter(
          (name) => !data.some((item) => item.name === name),
        ),
      });
    } else {
      setFilters({
        ...filters,
        itemStatus: [],
        multiItemStatus: Array.from(
          new Set([
            ...filters.multiItemStatus,
            ...data.map((item) => item.name),
          ]),
        ),
      });
    }
  };

  return (
    <AllOptionBox>
      <AllOptionBoxContent>
        <CategoryBox>
          <OptionItem
            onClick={() => {
              if (isSelectedAllOptions) {
                setFilters({
                  ...filters,
                  multiItemStatus: [],
                });
              } else {
                toggleAllSelect(isSelectedAllOptions, [
                  ...PTypeLandCategoty,
                  ...PTypeResidentialCategory,
                  ...PTypeCommercialCategory,
                  ...PTypeIndustrialCategory,
                  ...PTypeComplexCategory,
                ]);
              }
            }}
          >
            <img
              src={`/assets/images/check/${isSelectedAllOptions ? 'check-blue-on' : 'check-blue-off'}.svg`}
              alt="Check"
            />
            <span>전체선택</span>
          </OptionItem>
        </CategoryBox>
        <CategoryBox>
          <div>토지</div>
          <OptionBox>
            <OptionItem
              onClick={() => toggleAllSelect(allSelected1, PTypeLandCategoty)}
            >
              <img
                src={`/assets/images/check/${allSelected1 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>토지전체</span>
            </OptionItem>
            {PTypeLandCategoty.map((item, index) => (
              <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                <img
                  src={`/assets/images/check/${filters.multiItemStatus.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </OptionBox>
        </CategoryBox>
        <CategoryBox>
          <div>주거용건물</div>
          <OptionBox>
            <OptionItem
              onClick={() => {
                toggleAllSelect(allSelected2, PTypeResidentialCategory);
              }}
            >
              <img
                src={`/assets/images/check/${allSelected2 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>주거용건물전체</span>
            </OptionItem>
            {PTypeResidentialCategory.map((item, index) => (
              <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                <img
                  src={`/assets/images/check/${filters.multiItemStatus.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </OptionBox>
        </CategoryBox>
        <CategoryBox>
          <div>상가용및업무용건물</div>
          <OptionBox>
            <OptionItem
              onClick={() => {
                toggleAllSelect(allSelected3, PTypeCommercialCategory);
              }}
            >
              <img
                src={`/assets/images/check/${allSelected3 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>상가용및업무용건물 전체</span>
            </OptionItem>
            {PTypeCommercialCategory.map((item, index) => (
              <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                <img
                  src={`/assets/images/check/${filters.multiItemStatus.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </OptionBox>
        </CategoryBox>
        <CategoryBox>
          <div>산업용및기타특수용건물</div>
          <OptionBox>
            <OptionItem
              onClick={() => {
                toggleAllSelect(allSelected4, PTypeIndustrialCategory);
              }}
            >
              <img
                src={`/assets/images/check/${allSelected4 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>산업용및기타특수용건물 전체</span>
            </OptionItem>
            {PTypeIndustrialCategory.map((item, index) => (
              <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                <img
                  src={`/assets/images/check/${filters.multiItemStatus.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </OptionBox>
        </CategoryBox>
        <CategoryBox>
          <div>용도복합용건물</div>
          <OptionBox>
            <OptionItem
              onClick={() => {
                toggleAllSelect(allSelected5, PTypeComplexCategory);
              }}
            >
              <img
                src={`/assets/images/check/${allSelected5 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>용도복합용건물 전체</span>
            </OptionItem>
            {PTypeComplexCategory.map((item, index) => (
              <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                <img
                  src={`/assets/images/check/${filters.multiItemStatus.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </OptionBox>
        </CategoryBox>
      </AllOptionBoxContent>
    </AllOptionBox>
  );
};

export default PItemStatusOption;

const AllOptionBox = styled.div`
  width: 100%;
  margin-top: 2px;
  border: 1px solid #e1e2e4;
  border-radius: 8px;
`;
const AllOptionBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CategoryBox = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-bottom: 1px solid #e1e2e4;
  font-size: 14px;
  font-weight: 700;
  color: #222;
`;
const OptionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
`;

const OptionItem = styled.div`
  display: flex;
  width: calc((100% - 12px) / 2);
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  gap: 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.78);
  white-space: wrap;
`;
